import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  CircularProgress,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PageLayout from '../../components/layout/PageLayout';
import api from '../../api/config';
import { BRANDS } from '../../api/endpoints';
import { toast } from 'react-toastify';
import { buildBrandRelationParams } from './brandApiHelpers';

const row = (label, value) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
      {value ?? '—'}
    </Typography>
  </Grid>
);

const ViewBrand = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [b, setB] = useState(null);
  
  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(BRANDS.BY_ID(id), {
          params: buildBrandRelationParams(),
        });
        const payload = data?.data ?? data;
        if (!cancelled) setB(payload);
      } catch (err) {
        toast.error(err.response?.data?.message || 'Failed to load brand');
        navigate('/brands');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, navigate]);

  if (loading || !b) {
    return (
      <PageLayout>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight={320}>
          <CircularProgress />
        </Box>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/brands')} sx={{ mb: 2 }}>
          Back to brands
        </Button>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="h4" sx={{ fontWeight: 600, color: 'primary.main' }}>
            {b.name ?? 'Brand'}
          </Typography>
          <Button variant="outlined" size="small" onClick={() => navigate(`/brands/edit/${id}`)}>
            Edit
          </Button>
        </Box>

        <Card>
          <CardContent sx={{ p: 3 }}>
            <Grid container spacing={2}>
              {row('Name', b.name)}
              {row('Type', b.type)}
              {row('URL', b.url)}
              {row('Address', b.address)}
              {row('Invoice limit', b.invoice_limit != null ? String(b.invoice_limit) : '—')}
              {row('Brand category', b.brandCategory?.name ?? b.brand_category?.name)}
              {row(
                'Payment account',
                b?.brand_payment_accounts?.[0]?.payment_accounts?.account_name ?? "null"
              )}
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </PageLayout>
  );
};

export default ViewBrand;
